import moment from "moment";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";

import {
  FLOW_STATUS_COLORS,
  FLOW_STATUS_LABELS,
  FLOW_TRIGGER_LABELS
} from "../../constants";
import { MarketingFlow } from "../../marketing.types";
import { StatusDot } from "../StatusDot";

import styles from "./FlowCards.module.scss";

interface FlowCardsProps {
  flows: MarketingFlow[];
  isLoading?: boolean;
}

const FlowCards = ({ flows, isLoading }: FlowCardsProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (isLoading) {
    return <Skeleton count={3} height={120} borderRadius={16} />;
  }

  if (!flows.length) {
    return <p className={styles.empty}>{t("No flows yet")}</p>;
  }

  return (
    <div className={styles.grid}>
      {flows.map((flow) => (
        <button
          key={flow.id}
          type="button"
          className={styles.card}
          onClick={() => navigate(`/marketing/flows/${flow.id}`)}
        >
          <div className={styles.card__header}>
            <span className={styles.card__name}>{flow.name}</span>
            <StatusDot color={FLOW_STATUS_COLORS[flow.status]} />
          </div>

          <div className={styles.card__badges}>
            <span className={styles.card__trigger}>
              ⚡ {t(FLOW_TRIGGER_LABELS[flow.trigger])}
            </span>
            <span className={styles.card__status}>
              {t(FLOW_STATUS_LABELS[flow.status])}
            </span>
          </div>

          <span className={styles.card__date}>
            {t("Created")} {moment(flow.createdAt).format("DD/MM/YYYY")}
          </span>
        </button>
      ))}
    </div>
  );
};

export default FlowCards;
